<div
  class="scv2-carrier-mark"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.background]="color"
  [style.fontSize.px]="size * 0.26"
>
  {{ text }}
</div>
